import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { getBooleanFF } from '@atlaskit/platform-feature-flags';
import { sendScreenEvent, sendTrackEvent, sendUIEvent } from '../../../common/utils/analytics-client';
import { Logger } from '../../../common/utils/logger';
import { updatePreferences } from '../../../controllers/storage-preferences/update-preferences';
import { CookieCategory } from '../../../types';
import { PresentationalPreferenceModal } from './presentational-preference-modal';
export var PreferenceModal = function PreferenceModal(props) {
  // feature flag check
  if (!getBooleanFF('platform.moonjelly.browser-storage-controls')) {
    return null;
  }
  return /*#__PURE__*/React.createElement(PreferenceModalImpl, props);
};
export var PreferenceModalImpl = function PreferenceModalImpl(_ref) {
  var _useState5;
  var onClose = _ref.onClose,
    onSubmit = _ref.onSubmit,
    showSuccessFlag = _ref.showSuccessFlag,
    showErrorFlag = _ref.showErrorFlag;
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isModalOpen = _useState2[0],
    setIsModalOpen = _useState2[1];
  var isEventSent = useRef(false);
  useEffect(function () {
    if (!isEventSent.current) {
      sendScreenEvent({
        name: 'cookieConsentModal'
      });
      isEventSent.current = true;
    }
  }, [isEventSent]);
  var _useState3 = useState((_useState5 = {}, _defineProperty(_useState5, CookieCategory.StrictlyNecessary, true), _defineProperty(_useState5, CookieCategory.Functional, false), _defineProperty(_useState5, CookieCategory.Marketing, false), _defineProperty(_useState5, CookieCategory.Analytics, false), _defineProperty(_useState5, CookieCategory.Unknown, false), _useState5)),
    _useState4 = _slicedToArray(_useState3, 2),
    preferences = _useState4[0],
    setPreferences = _useState4[1];
  var handleOnSubmit = useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(displayedTextMap) {
      var selectedPreferences;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            selectedPreferences = preferences;
            sendUIEvent({
              action: 'clicked',
              actionSubject: 'button',
              actionSubjectId: 'confirm',
              source: 'cookieConsentModal'
            });
            _context.prev = 2;
            _context.next = 5;
            return updatePreferences(selectedPreferences, displayedTextMap);
          case 5:
            sendTrackEvent({
              source: 'cookieConsentModal',
              action: 'submitted',
              actionSubject: 'cookieConsentPreferences'
            });
            showSuccessFlag === null || showSuccessFlag === void 0 || showSuccessFlag();
            _context.next = 13;
            break;
          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](2);
            Logger.errorWithOperationalEvent({
              action: 'updatePreferencesError',
              attributes: {
                preferences: selectedPreferences
              },
              message: "Failed to update preferences from modal. ".concat(_context.t0.message || '')
            });
            showErrorFlag === null || showErrorFlag === void 0 || showErrorFlag();
          case 13:
            setIsModalOpen(false);
            onSubmit === null || onSubmit === void 0 || onSubmit();
          case 15:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 9]]);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [preferences, onSubmit, showSuccessFlag, showErrorFlag]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, isModalOpen && /*#__PURE__*/React.createElement(PresentationalPreferenceModal, {
    setPreferences: setPreferences,
    onSubmit: handleOnSubmit,
    onClose: onClose,
    setIsOpen: setIsModalOpen,
    preferences: preferences
  }));
};